export enum Role {
    SA_ROLE = '36a34a0d-c41c-4663-b1ec-674f38c52193',
    TENANT_ADMIN_ROLE = '952636ea-49d4-4a45-869b-105f2de1f5df',
    WL_ADMIN_ROLE = 'c10b380f-4991-4d4a-bf49-4eee47d59152',
    AF_USER_ROLE = 'e1dbba33-d956-41fc-83a4-3fc3214fe739',
    CLI_USER_ROLE = '2342a094-1ef6-4f5a-a15e-303198353efa',
}
